import { HomeHero } from '../components/sections/HomeHero';
import { HomeAboutPreview } from '../components/sections/HomeAboutPreview';
import { HomeWhyChooseUs } from '../components/sections/HomeWhyChooseUs';
import { HomeProgramsPreview } from '../components/sections/HomeProgramsPreview';
import { HomeTestimonials } from '../components/sections/HomeTestimonials';
import { HomeGalleryPreview } from '../components/sections/HomeGalleryPreview';
import { HomeFaqs } from '../components/sections/HomeFaqs';
import { HomeEnrollmentCta } from '../components/sections/HomeEnrollmentCta';

export const HomePage = () => (
  <div className="pt-20" data-testid="home-page">
    <HomeHero />
    <HomeAboutPreview />
    <HomeWhyChooseUs />
    <HomeProgramsPreview />
    <HomeTestimonials />
    <HomeGalleryPreview />
    <HomeFaqs />
    <HomeEnrollmentCta />
  </div>
);
